import { Pipe, PipeTransform, inject } from '@angular/core';
import { JurisdictionMetadataKey } from './jurisdiction.data';
import { Observable, map } from 'rxjs';
import { JurisdictionsService } from 'src/app/components/shared/services/jurisdictions.service';

@Pipe({
	name: 'hideByJurisdiction',
	standalone: true,
})
export class HideByJurisdictionPipe implements PipeTransform {
	private jurisdictionsService = inject(JurisdictionsService);


	constructor() {}
	transform(value: JurisdictionMetadataKey): Observable<boolean> {
		return this.jurisdictionsService.getMetadata(value).pipe(
			map((result) => {
				return result?.hide;
			})
		);
	}
}

